import React, { useState } from "react";
import { ChevronDown, ChevronUp, MessageSquareQuote } from "lucide-react";

const METRICS = [
  { key: "technical_accuracy", label: "Technical Accuracy" },
  { key: "clarity", label: "Clarity" },
  { key: "structure", label: "Structure" },
  { key: "confidence", label: "Confidence" },
];

const ACCENT_BAR = { indigo: "bg-indigo-400", teal: "bg-teal-400", fuchsia: "bg-fuchsia-400" };

export default function AnswerScoreCard({ scores, idealAnswer, feedback, fillerWordCount, wpm, accent = "indigo" }) {
  const [showIdeal, setShowIdeal] = useState(false);
  const barClass = ACCENT_BAR[accent] || ACCENT_BAR.indigo;

  return (
    <div className="glass-panel rounded-2xl p-5 space-y-4" data-testid="answer-score-card">
      <div className="space-y-3">
        {METRICS.map((m) => (
          <div key={m.key} data-testid={`score-bar-${m.key}`}>
            <div className="flex justify-between text-xs text-slate-400 mb-1">
              <span>{m.label}</span>
              <span className="text-white font-semibold">{scores[m.key]}</span>
            </div>
            <div className="h-1.5 bg-white/10 rounded-full overflow-hidden">
              <div className={`h-full ${barClass} rounded-full transition-all duration-500`} style={{ width: `${scores[m.key]}%` }} />
            </div>
          </div>
        ))}
      </div>

      {(fillerWordCount !== undefined || wpm !== undefined) && (
        <div className="flex items-center gap-3 text-xs" data-testid="answer-speech-metrics">
          {wpm > 0 && <span className="bg-white/5 border border-white/10 rounded-full px-2.5 py-1 text-slate-300">{wpm} WPM</span>}
          <span className="bg-white/5 border border-white/10 rounded-full px-2.5 py-1 text-slate-300">{fillerWordCount || 0} filler words</span>
        </div>
      )}

      {feedback && <p className="text-sm text-slate-300 italic">"{feedback}"</p>}

      <button
        onClick={() => setShowIdeal((v) => !v)}
        data-testid="toggle-ideal-answer-btn"
        className="flex items-center gap-1.5 text-xs font-semibold text-slate-400 hover:text-white"
      >
        <MessageSquareQuote className="w-3.5 h-3.5" /> {showIdeal ? "Hide" : "See"} Ideal Answer
        {showIdeal ? <ChevronUp className="w-3.5 h-3.5" /> : <ChevronDown className="w-3.5 h-3.5" />}
      </button>
      {showIdeal && (
        <div className="bg-white/5 border border-white/10 rounded-xl p-3.5 text-sm text-slate-300 leading-relaxed" data-testid="ideal-answer-text">
          {idealAnswer}
        </div>
      )}
    </div>
  );
}
